import useSWR, { KeyedMutator } from 'swr';
import { fetcher } from "./fetcher";
import { UserProfileData } from "@app/core-app/app/usecase/fetch-user-profile";

export type ProfileData = {
    data: UserProfileData;
    isLoading: boolean;
    isError: any;
    isValidating: boolean;
    mutate: KeyedMutator<UserProfileData>;
};

export const PROFILE_DATA_KEY = "/api/profile";

// Define a type for the hook's parameters
type UseProfileParams = {
    isAuthorized?: boolean; // Make it optional and default to true
};

export function useProfile({ isAuthorized = true }: UseProfileParams = {}): ProfileData {
  const { data, error, mutate, isValidating } = useSWR(
    isAuthorized ? PROFILE_DATA_KEY : null, // Only fetch when authorized
    fetcher
  );

  return {
    data: data?.data,
    isLoading: isAuthorized && !error && !data,
    isError: error,
    isValidating,
    mutate
  };
}
